import React from 'react';
import { motion } from 'framer-motion';
import '../styles/About.css';


const About = () => {
  return (
    <section className="about-section" id="about">
      <motion.h1
        initial={{ opacity: 0, y: -30 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8 }}
      >
        {/* ABOUT US */}
      </motion.h1>

      <motion.p
        className="intro-text"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 0.3, duration: 0.8 }}
      >
        FOLKLORE Acume is named after the word acumen meaning ‘the ability to make good judgements and take quick decisions’. History and etymology of the same has its root to the Latin word acūmen. Our story began in 2013, Back then we were a company providing manpower services front and centered to testing and commissioning. Today, we are privileged to say that we have extended our range of services from manpower to turnkey projects; registering Acume as a key subcontracting company in Energy, Power, Infrastructure and Oil & Gas sectors.
      </motion.p>

    </section>
  );
};

export default About; 